export default "__VITE_ASSET__C25Lv9Zl__"